import { ArrowRight } from '@/ui/icons';
import PropTypes from 'prop-types';

// One card in the "Foco del día" grid — a diligencia that requires action today.
// Presentational: the tone/label/what sentence + navigation target are derived
// upstream (Dashboard page) from the diligenciaDisplay model.
export default function FocusCard({
  tone,
  tagLabel,
  idLabel,
  what,
  caratula,
  ctaLabel,
  onClick,
}) {
  return (
    <button type="button" className="focus-card" onClick={onClick}>
      <div className="focus-card__top">
        <span className={`tag tag--${tone}`}>{tagLabel}</span>
        <span className="dash-feed__id">{idLabel}</span>
      </div>
      <p className="focus-card__what">{what}</p>
      <div className="focus-card__foot">
        <span className="note">{caratula}</span>
        <span className="focus-card__cta">
          {ctaLabel} <ArrowRight size={13} />
        </span>
      </div>
    </button>
  );
}

FocusCard.propTypes = {
  tone: PropTypes.string.isRequired,
  tagLabel: PropTypes.string.isRequired,
  idLabel: PropTypes.string,
  what: PropTypes.node.isRequired,
  caratula: PropTypes.string,
  ctaLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
